import { render } from "./mutualFriends.vue?vue&type=template&id=7bedd3d4"
import script from "./mutualFriends.vue?vue&type=script&lang=js"
export * from "./mutualFriends.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__